/* VIAPHARMA CUSTOMIZATION: updateCardUI returns early if .card-qty-counter element not found. See CUSTOMIZATIONS.md §10. */
(function () {
  // Update all card counters whenever any part of the app changes the cart
  subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
    if (event && event.cartData && event.cartData.items) {
      updateAllCounters(event.cartData.items);
    }
  });

  // Set initial counter state from live cart on page load
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) { updateAllCounters(cart.items); })
    .catch(function (err) { console.error('card-qty-counter: failed to load cart', err); });

  function updateAllCounters(cartItems) {
    document.querySelectorAll('.quick-add[data-card-variant-id]').forEach(function (container) {
      var variantId = parseInt(container.dataset.cardVariantId, 10);
      var cartItem = cartItems.find(function (item) { return item.variant_id === variantId; });
      updateCardUI(container, cartItem ? cartItem.quantity : 0);
    });
  }

  function updateCardUI(container, qty) {
    var addBtn = container.querySelector('.quick-add__submit');
    var chooseBtn = container.querySelector('.button-2');
    var counter = container.querySelector('.card-qty-counter');
    if (!counter) return;

    if (qty > 0) {
      if (addBtn) addBtn.classList.add('hidden');
      if (chooseBtn) chooseBtn.classList.add('hidden');
      counter.classList.remove('hidden');
      counter.querySelector('.card-qty-counter__value').textContent = qty;
    } else {
      if (addBtn) addBtn.classList.remove('hidden');
      if (chooseBtn) chooseBtn.classList.remove('hidden');
      counter.classList.add('hidden');
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-action]');
    if (!btn) return;

    var container = btn.closest('.quick-add[data-card-variant-id]');
    if (!container) return;

    e.preventDefault();

    var variantId = parseInt(container.dataset.cardVariantId, 10);
    var valueEl = container.querySelector('.card-qty-counter__value');
    var currentQty = parseInt(valueEl.textContent, 10);
    var newQty = btn.dataset.qtyAction === 'increase' ? currentQty + 1 : currentQty - 1;

    // Optimistic UI update before the network request
    updateCardUI(container, Math.max(0, newQty));

    // Disable buttons during request to prevent double-clicks
    container.querySelectorAll('[data-qty-action]').forEach(function (b) { b.disabled = true; });

    fetch(window.routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: newQty < 0 ? 0 : newQty }),
    })
      .then(function (r) { return r.json(); })
      .then(function (cartData) {
        // Publishing cartUpdate triggers CartDrawerItems.onCartUpdate() automatically,
        // which re-renders the cart drawer, and also our own subscriber above,
        // which corrects all card counters to match real server state.
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'card-qty-counter', cartData: cartData });
      })
      .catch(function (err) {
        console.error('card-qty-counter: update failed', err);
        // Revert optimistic update
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) { updateAllCounters(cart.items); });
      })
      .finally(function () {
        container.querySelectorAll('[data-qty-action]').forEach(function (b) { b.disabled = false; });
      });
  });
})();
